// React types
import { CSSProperties, ElementType, ReactNode } from "react";

// MUI
import { Paper } from "@mui/material";

type RoundedBoxProps = {
	component?: ElementType;
	sx?: CSSProperties; //deprecated in the future
	children?: ReactNode;
	className?: string; //ONLY Tailwind CSS classes, use this instead of sx
};
export default function RoundedBox(props: Readonly<RoundedBoxProps>) {
	const { component = "div", sx, children, className = "" } = props;
	return (
		<Paper elevation={0} className={`white-rounded-box w-[100%] ${className}`} sx={sx} component={component}>
			{children}
		</Paper>
	);
}
